import { AppErrors } from './app.errors';

export class UnauthorizedError extends AppErrors {}

